var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"id":"results"}},[_c('v-card-title',[_vm._v(" Voting results ")]),_c('v-card-text',[_c('v-data-table',{attrs:{"headers":_vm.resultsHeaders,"items":_vm.results}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }